import {Accordion, Column, Text} from 'components-lib';
import {FormNameEnum} from 'filters-selections/enums';
import {
  fetchInstrumentStatusesThunk,
  filtersInstrumentStatusesEntitiesCollectionSelector,
} from 'filters-selections/store';
import {Form} from 'forms';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {IWithDisabled} from 'models';

export function InstrumentStatusFilter({disabled}: IWithDisabled) {
  const dispatch = useDispatch();
  const statuses = useSelector(filtersInstrumentStatusesEntitiesCollectionSelector);

  useEffect(() => {
    if (!statuses.length) {
      dispatch(fetchInstrumentStatusesThunk());
    }
  }, [statuses.length, dispatch]);

  return (
    <Accordion heading="Status">
      <Column>
        {statuses.length ? (
          statuses.map((status) => (
            <Form.Checkbox
              key={status.id}
              name={FormNameEnum.instrumentStatus}
              value={status.id}
              label={status.displayText}
              disabled={disabled}
            />
          ))
        ) : (
          <Text.Caption>No Statuses</Text.Caption>
        )}
      </Column>
    </Accordion>
  );
}
